import React from 'react'
import ProductDetailDescription from './ProductDetailDescription'
import ProductOthers from './ProductOthers'

export default function ProductMainDetail({initialData}) {
  return (
    <>
      <ProductDetailDescription initialData={initialData?.detailpage} />
      <ProductOthers className="related-other-products" initialData={initialData?.listpage} />

    </>
  )
}
